import styled from 'styled-components';
import { lineHeight, theme, toRem } from 'design';

const ActionMenuListTitle = styled.span`
  display: flex;
  flex-shrink: 0;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${toRem(24)};
  margin-bottom: ${toRem(theme.space.xs)};
  padding: 0 ${toRem(theme.space.md)};
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.medium};
  font-size: ${toRem(theme.font.size.xxs)};
  line-height: ${lineHeight(theme.font.size.xxs)};
  color: ${theme.color.neutral[500]};
`;

export default ActionMenuListTitle;
